import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

import { ChevronRight, LoaderCircle } from 'lucide-vue-next';
    import Button from '@/components/ui/button/Button.vue';
    import { ref, watch } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableSearchButton',
  props: {
    isFetching: { type: Boolean }
  },
  emits: ["refetch"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const isLoading = ref(false);

    watch(
        () => props.isFetching,
        (newVal, oldVal) => {
            if (oldVal === true && newVal === false) {
                isLoading.value = false;
            }
        },
    );

    const emit = __emit;

    const handleRefetch = () => {
        isLoading.value = true;
        emit('refetch');
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Button, {
    variant: "ghost_primary",
    width: "narrow",
    class: "self-start",
    size: "xs",
    onClick: handleRefetch,
    disabled: _ctx.isFetching
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('activities.search')) + " ", 1),
      (!isLoading.value)
        ? (_openBlock(), _createBlock(_unref(ChevronRight), {
            key: 0,
            class: "text-primary"
          }))
        : (_openBlock(), _createBlock(_unref(LoaderCircle), {
            key: 1,
            class: "text-primary animate-spin"
          }))
    ]),
    _: 1
  }, 8, ["disabled"]))
}
}

})